import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { SnackBarService } from 'app/services/snackbar.service';
import { MessageService } from 'app/services/messages.service';
import { OrganisationDetails } from 'app/shared/models/org-details.model';

import { ClientHeaderService } from './../client-header.service';

@Component({
    selector: 'app-offboard-client',
    templateUrl: './offboard-client.component.html'
})

/**
 * Component to offboard client.
 */
export class OffboardClientComponent implements OnInit {
    organisationDetails: OrganisationDetails;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private clientHeaderService: ClientHeaderService,
        private snackBarService: SnackBarService) { }

    ngOnInit() { }

    offboardClient() {
        let response = {
            'message': 'Client getting offboarded. Please wait...'
        };
        this.callSnackBarService(response, '', '');
        const postOrgData = {
            'entityId': this.organisationDetails.organisationVO.entityId,
        };
        this.clientHeaderService
            .offboardClient(postOrgData)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(response);
                }
                this.callSnackBarService(response,
                    MessageService.OFFBOARD_CLIENT_SUCCESS,
                    MessageService.OFFBOARD_CLIENT_FAILURE);
            },
            err => {
                this.callSnackBarService(err,
                    MessageService.OFFBOARD_CLIENT_SUCCESS,
                    MessageService.OFFBOARD_CLIENT_FAILURE);
            });
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/offboardclient/offboard-client.component.ts